import {Modal, Progress} from "antd";
import React from "react";

export interface ProgressModalProp
{
    visible:boolean,
    title:string,
    percent:number,
}

function  ProgressModal(props:ProgressModalProp)
{
    const {visible, title, percent} = props;
    return (
        <Modal
            centered
            open={visible}
            title={title}
            footer={null}
            closable={false}
        >
            <Progress percent={percent} status="active" />
        </Modal>
    );
}
export default ProgressModal;
